import React from 'react';
import { Button, Table, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FieldArray } from 'formik';

const EllipsizeWithTooltip = React.memo(({ id, text = '', max = 20, className }) => {
    const display = (text?.length || 0) > max ? `${text.slice(0, max - 1)}…` : text || '';
    if (!text) return <span className={className}>—</span>;
    return (
        <OverlayTrigger placement="top" overlay={<Tooltip id={id}>{text}</Tooltip>}>
            <span className={className} style={{ cursor: 'help' }}>{display}</span>
        </OverlayTrigger>
    );
});

const ShopRow = React.memo(function ShopRow({ item, index, onRemove }) {
    return (
        <tr>
            <td>
                <Badge bg="primary" className="w-100 text-start text-truncate">
                    <EllipsizeWithTooltip id={`tip-loc-${index}`} text={item.shop_location} max={999} className="d-inline-block" />
                </Badge>
            </td>
            <td>
                <EllipsizeWithTooltip id={`tip-company-${index}`} text={item.supplier_company_name} max={25} className="d-inline-block" />
            </td>
            <td className="text-truncate d-flex justify-content-between align-items-center">
                <EllipsizeWithTooltip id={`tip-name-${index}`} text={item.shop_name} max={30} className="flex-grow-1 text-truncate me-2" />
                <Button size="sm" variant="outline-danger" onClick={onRemove} className="flex-shrink-0">
                    Remove
                </Button>
            </td>
        </tr>
    );
});

export default function DiscountShopTable({ values }) {
    return (
        <FieldArray name="shops">
            {({ remove }) => (
                <Table className="my-1" striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th style={{ width: 160 }}>Location</th>
                            <th style={{ width: 240 }}>Company</th>
                            <th>Shop</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(Array.isArray(values.shops) ? values.shops : []).map((item, index) => (
                            <ShopRow
                                key={item.shop_id ?? index}
                                item={item}
                                index={index}
                                onRemove={() => remove(index)}
                            />
                        ))}
                        {(!Array.isArray(values.shops) || values.shops.length === 0) && (
                            <tr>
                                <td colSpan={3} className="text-muted">
                                    No shops selected yet.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            )}
        </FieldArray>
    );
}